
import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare, HelpCircle } from 'lucide-react';
import EnhancedFeedbackDialog from './EnhancedFeedbackDialog';
import { usePostHogSurveys } from '@/hooks/usePostHogSurveys';

interface FeedbackTriggerProps {
  variant?: 'button' | 'floating' | 'inline';
  section?: string;
  type?: string;
  text?: string;
}

const FeedbackTrigger: React.FC<FeedbackTriggerProps> = ({ 
  variant = 'button',
  section = '',
  type = 'suggestion',
  text = 'Feedback'
}) => {
  const { triggerFeedbackSurvey } = usePostHogSurveys();

  const handleClick = () => {
    // Also trigger PostHog survey if configured
    triggerFeedbackSurvey('general');
  };

  if (variant === 'floating') {
    return (
      <div className="fixed bottom-20 md:bottom-4 left-4 z-30">
        <EnhancedFeedbackDialog defaultSection={section} defaultType={type}>
          <Button
            onClick={handleClick}
            className="rounded-full w-12 h-12 shadow-lg bg-background/95 backdrop-blur-sm border border-border hover:bg-muted/80"
            size="icon"
            variant="outline"
          >
            <MessageSquare className="w-5 h-5" />
          </Button>
        </EnhancedFeedbackDialog>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <EnhancedFeedbackDialog defaultSection={section} defaultType={type}>
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-muted-foreground hover:text-foreground"
          onClick={handleClick}
        >
          <HelpCircle className="w-4 h-4 mr-1" />
          {text}
        </Button>
      </EnhancedFeedbackDialog>
    );
  }

  return (
    <EnhancedFeedbackDialog defaultSection={section} defaultType={type}>
      <Button variant="outline" onClick={handleClick}>
        <MessageSquare className="w-4 h-4 mr-2" />
        {text}
      </Button>
    </EnhancedFeedbackDialog>
  );
};

export default FeedbackTrigger;
